import Glossary from '@/components/Glossary';
import SEOHead from '@/components/SEOHead';

const GlossaryPage = () => {
  return (
    <>
      <SEOHead />

      <div>
        <section className="products section hero v9">
          <div className="container-default w-container">
            <div className="z-index-1">
              <div className="mg-bottom-78px">
                <div className="inner-container center">
                  <div className="inner-container _861px---tablet center">
                    <div className="text-center">
                      <div className="mg-bottom-24px">
                        <div className="text-100 bold color-accent-1 text-uppercase">
                          <p>Brand your emails. Get more opens.</p>
                        </div>
                      </div>
                      <h1 className="display-1 color-neutral-100 mg-bottom-24px">
                        Glossary of Terms
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="position-absolute card-top-bg---bottom pricing-bg" />
        </section>

        <div id="certificate_request_app" className="bg-neutral-100">
          <div className="container-default w-container">
            <div className="mg-bottom-80px">
              <div className="inner-container">
                <Glossary />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlossaryPage;
